/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import SiteServicesMenu from './SiteServicesMenu';
import Touch from '../../../utilities/Touch';
import ZIndex from '../../constants/ZIndex';
import withRouterAndCopiedProperties from '../withRouterAndCopiedProperties';

class PopoverSiteServicesMenu extends React.Component<
  {
    history: Object,
    target: HTMLElement,
  },
  {
    show: boolean,
    left: number,
  }
> {
  rootElement: HTMLElement;
  containerElement: HTMLElement;
  closeTimeout: any;
  browserHistoryListener: Function;
  state = {
    show: false,
    left: 0,
  };

  _onClickBody = () => {
    if (Touch.isDragging) {
      this.hide(true);
    }
  };

  _onMouseLeaveContainer = () => {
    this.hide();
  };

  _onMouseEnterContainer = () => {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }
  };

  componentDidMount() {
    let { history } = this.props;
    document.body.addEventListener(
      Touch.supported ? 'touchend' : 'click',
      this._onClickBody,
      false
    );
    this.browserHistoryListener = history.listen(() => {
      this.hide(true);
    });
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this._onClickBody, false);
    if (this.browserHistoryListener) {
      this.browserHistoryListener();
    }
  }

  show() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
    }

    let { target } = this.props;
    if (!target) return;
    let windowWidth =
      window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    let targetRect = target.getBoundingClientRect();
    let targetCenterX = targetRect.left + targetRect.width / 2;
    let rootRect = this.rootElement.getBoundingClientRect();

    let menuContainerRect = this.containerElement.getBoundingClientRect();
    let left = targetCenterX - menuContainerRect.width / 2 - (windowWidth - rootRect.width) / 2;
    this.setState({ left, show: true });
  }

  hide(force = false) {
    if (this.servicesLinkCloseTimeout) {
      clearTimeout(this.servicesLinkCloseTimeout);
    }

    const hide = () => {
      this.setState({ show: false });
    };

    if (force) {
      hide();
    } else {
      this.closeTimeout = setTimeout(hide, 100);
    }
  }

  toggle(force = false) {
    let { show } = this.state;
    if (show) {
      this.hide(force);
    } else {
      this.show();
    }
  }

  render() {
    let { left, show } = this.state;

    return (
      <div
        className={Styles.Root}
        style={{ pointerEvents: show ? 'auto' : 'none' }}
        ref={ref => (this.rootElement = ref)}>
        <div
          className={Styles.Container}
          style={{
            transform: `translateX(${left}px)`,
            opacity: show ? 1 : 0,
          }}
          onMouseLeave={this._onMouseLeaveContainer}
          onMouseEnter={this._onMouseEnterContainer}
          ref={ref => (this.containerElement = ref)}>
          <SiteServicesMenu />
        </div>
      </div>
    );
  }
}

const Styles = {
  Root: css`
    position: absolute;
    top: 80px;
    left: 0;
    right: 0;
    z-index: ${ZIndex.Highest};
  `,
  Container: css`
    position: absolute;
    top: 0;
    left: 0;
    will-change: opacity;
    transition-property: opacity;
    transition-duration: 200ms;
    display: inline-block;
  `,
};

export default withRouterAndCopiedProperties(PopoverSiteServicesMenu);



// WEBPACK FOOTER //
// ./src/ui/components/chrome/PopoverSiteServicesMenu.js